import ApiConstant from "../../constants/api.constants";
import api from "../api";


const gstGSTSalesReportsList = async (filter:any) => {
        try {
        const response = await api.post(ApiConstant.getGSTSalesReportsList,filter)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
}

const gstGSTSalesReportsListExport = async (filter:any) => {
        try {
        const response = await api.post(ApiConstant.getGSTSalesReportsListExports,filter)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
}

const gstPOSTargetMapping = async (filter:any) => {
        try {
        const response = await api.post(ApiConstant.getPOSTargetMapping,filter)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
}

const updatePOSTargetMapping = async (filter:any) => {
        try {
        const response = await api.put(ApiConstant.updatePOSTargetMappingList,filter)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
}

const getPOSTargetMappingMonthList = async (filter:any) => {
        try {
        const response = await api.post(ApiConstant.getPOSTargetMappingMonthList,filter)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
}

const reportsServices = {
    gstGSTSalesReportsList,
    gstGSTSalesReportsListExport,
    gstPOSTargetMapping,
    updatePOSTargetMapping,
    getPOSTargetMappingMonthList
};

export default reportsServices;